import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert } from '@shared-app/ui/Alert/Alert';
import palette from '@theme/palette';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
export function FeedbackAlert() {
    const { t } = useTranslation();
    return (_jsx(Alert, { sx: { bgcolor: palette.primary[95] }, icon: false, children: _jsxs("div", { className: styles.filterText, children: [t('Try using'), " ", _jsx("span", { style: { color: palette.primary['50'] }, children: t('Filters') }), ' ', t('to narrow down the number of original solutions to improve accuracy.')] }) }));
}
